import StockoutDealerPanel from './stockoutDealerPanel.container'

export default StockoutDealerPanel;

